// extracted by mini-css-extract-plugin
export default {"overlay":"jx-z","bodyOpen":"kx-z","content":"lx-z","header":"mx-z","close":"nx-z","closeNoHeading":"ox-z"};